import React from "react";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";
import ChallengerConversionModule from "./challengerConversion/index";
import PackageSalesModule from "./packagesSales/index";

const pageConfig = {
  pageName: "Packages",
  configuratorWidth: { dark: 410, light: 380 },
  moduleList: [PackageSalesModule, ChallengerConversionModule]
};

const PackagesPage = ({ notifications }) => (
  <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />
);

export default PackagesPage;
